(function () {
  'use strict';

  const slideshow = $( '.slideshow' )
  
  if (!slideshow.length) return
  
  let intervalTime = parseInt(slideshow.data( 'slideshow-duration' ), 10) || 2000

  const slides = $( '.slideshow img' )
  const controls = $( '.slideshow-control' )
  const text = $( '.slideshow-text' )

  let currentIndex = 0
  let timer

  slides.each(function (i) {
	  $(this).removeClass( 'block hidden' )
  })

  function showSlide(index) {
    slides.each(function (i) {
      $(this).toggleClass( 'active', i === index )
    })

    controls.each(function (i) {
      const dot = $(this).find( '.dot' )
      const highlight = text.find('span[data-slide="' + ( i+1 ) + '"]')

      let color = highlight.data( 'highlight-color' )
	  
      if (i === index) {
          dot.removeClass( 'opacity-0' ).addClass( 'opacity-100 animate-pulse' )
          highlight.addClass( 'text-white' ).addClass( color ).removeClass( 'highlight-gray-200' )
        } else {
          dot.removeClass( 'opacity-100 animate-pulse' ).addClass( 'opacity-0' )
          highlight.removeClass( 'text-white' ).removeClass( color ).addClass( 'highlight-gray-200' )
        }
    })

    currentIndex = index
  }

  function nextSlide() {
    let newIndex = (currentIndex + 1) % slides.length
    showSlide(newIndex)
  }

  function startSlideshow() {
    timer = setInterval(nextSlide, intervalTime)
  }

  function restartSlideshow() {
    clearInterval(timer)
    startSlideshow()
  }

  controls.on('click', function (e) {
    e.preventDefault()

    const slideIndex = parseInt($(this).data( 'slide' ), 10)
    showSlide(slideIndex)
    restartSlideshow()
  })

  showSlide(( parseInt(slideshow.data( 'slideshow-start' ), 10) - 1 ) ?? 0)

  startSlideshow()
})()